import { render, staticRenderFns } from "./CrewPage.vue?vue&type=template&id=3f45046b&scoped=true&"
import script from "./CrewPage.vue?vue&type=script&lang=js&"
export * from "./CrewPage.vue?vue&type=script&lang=js&"
import style0 from "./CrewPage.vue?vue&type=style&index=0&id=3f45046b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45046b",
  null
  
)

export default component.exports